<template>
    <resizable-page>
        <template v-slot:table>
            <v-data-table
                :height="'57.5vh'"
                :headers="tHeaders(tableHeaders)"
                :items="tableItems"
                :items-per-page="10"
                :footer-props="{
                    showFirstLastPage: false,
                    itemsPerPageOptions: [10, 20, 50],
                    itemsPerPageText: $t('table.itemsPerPage'),
                }"
                :search="search"
                sort-by="created_at"
                sort-desc
                multi-sort
                class="elevation-0 nowrap-headers"
                fixed-header
                :show-select="showSelect"
                :single-select="singleSelect"
            >
                <template v-slot:progress v-if="progress">
                    <v-progress-linear color="#154579" :height="5" indeterminate></v-progress-linear>
                </template>

                <template v-slot:item="{ item }">
                    <tr :data-id="item.id">
                        <template v-for="(value, key) in item">
                            <template v-if="key != 'active'">
                                <td class="truncate" :key="value.id" v-if="hideColumns(key)">
                                    {{ value }}
                                </td>
                            </template>

                            <template v-else>
                                <td :key="value.id" style="text-align: center">
                                    <v-simple-checkbox :value="value" disabled></v-simple-checkbox>
                                </td>
                            </template>
                        </template>

                        <td v-if="hasActions" style="text-align: center">
                            <slot name="actions" v-bind="{ item }"></slot>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </template>

        <template v-slot:filter>
            <v-row class="pb-6" justify="start" style="margin-top: -60px">
                <v-col cols="12" sm="12" md="4" class="pt-0 pl-0">
                    <v-text-field v-model="search" append-icon="mdi-magnify" :label="tb('Procurar')" single-line hide-details class="px-4"></v-text-field>
                </v-col>
            </v-row>
        </template>
    </resizable-page>
</template>

<script>
export default {
    props: {
        tableHeaders: Array,
        tableItems: Array,
        hideTableColumns: Array,

        showSelect: {
            type: Boolean,
            default: false,
        },
        singleSelect: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        search: '',
        progress: false,
    }),

    computed: {
        hasActions() {
            return !!this.$scopedSlots['actions'];
        },
    },

    methods: {
        hideColumns(column) {
            if (this.hideTableColumns.includes(column)) {
                return false;
            }
            return true;
        },
    },
};
</script>

<style>
.truncate {
    max-width: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.myprovet_datatable_header {
    color: #154579;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
}
</style>
